import React from "react";
import PropTypes from "prop-types";
import HorizontalLinkList from "../HorizontalLinkList";

const EnergyChartWindows = props => (
  <div className="cb-c-energy-chart__windows">
    <div
      style={{
        maxWidth: 50 * props.windows.length,
        display: "inline-block"
      }}
    >
      <HorizontalLinkList
        items={props.windows}
        selectedItem={props.selectedWindow}
        onChange={props.onChange}
      />
    </div>
  </div>
);

EnergyChartWindows.propTypes = {
  onChange: PropTypes.func.isRequired,
  windows: PropTypes.array.isRequired,
  selectedWindow: PropTypes.string
};

export default EnergyChartWindows;
